module.exports = __webpack_public_path__ + "img/banner.08d8cad1.jpg";